import request from "./API";

export const PostComment = (userId, data) => {
  return request.post(`/admin-form/comment/${userId}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
